import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import MobileHeroCard from './MobileHeroCard';
import MobileHeroCardContainer from './MobileHeroCard.container';
import MobileHeroCardV2 from '../MobileHeroCard.pp_benefits_mobile';

export default withFeatureBranch({ pp_benefits_mobile: MobileHeroCardV2 })(
  MobileHeroCardContainer(MobileHeroCard)
);
